<template>
  <div class="vm-container login-container">
    <div
      v-if="
        ssoEvaluatedUserStatusAction == 'ExternalUserReadyToLogin' &&
        ssoAreTermsAccepted
      "
    >
      <div
        class="loading_container d-flex justify-content-center align-items-center"
      >
        <div
          class="spinner-border text-primary"
          style="width: 5rem; height: 5rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div v-else class="auth__content login__box">
      <a class="back-link" @click="goToLogin()">
        <font-awesome-icon size="1x" :icon="['fas', 'chevron-left']" />
        {{ $t("ManageIdentity.Views.Manage.ChangePassword.btnBack") }}
      </a>
      <!-- <h1
        class="login__box__header"
        v-html="$t('ManageIdentity.Views.Account.Login.Headline')"
      />
      <div
        class="login__box__description"
        v-html="$t('ManageIdentity.Views.Account.Login.HeadlineClaim')"
      /> -->

      <div v-if="ssoEvaluatedUserStatusAction">
        <div class="d-none">
          <b>Status</b> = {{ ssoEvaluatedUserStatusAction }} <br />
          <b>Terms & Conditions</b> = {{ ssoAreTermsAccepted }}
        </div>

        <div
          v-if="
            ssoEvaluatedUserStatusAction == 'ExternalUserUnknown' ||
            (ssoEvaluatedUserStatusAction == 'ExternalUserReadyToLogin' &&
              !ssoAreTermsAccepted)
          "
        >
          <UserAcceptTerms
            :ssoEvaluatedUserStatusAction="ssoEvaluatedUserStatusAction"
          />
        </div>

        <div v-if="ssoEvaluatedUserStatusAction == 'ExternalUserWithNoIdentity'">
          <TransferUser :userData="TransferUser" :ssoStatus="ssoEvaluatedUserStatusAction" :withSso="true" />
        </div>

        <div
          v-if="
            ssoEvaluatedUserStatusAction ==
              'ExternalUserWithIdentityAndNoSSOLink' ||
            ssoEvaluatedUserStatusAction ==
              'ExternalUserWithIdentityAndNoPassword'"
        >
          <UserPasswordConfirm
            :userData="ssoUser"
            :areTermsAccepted="ssoAreTermsAccepted"
            :ssoEvaluatedUserStatusAction="ssoEvaluatedUserStatusAction"
            :return-url="returnUrl"
          />
        </div>

        <!-- <div
          v-if="ssoEvaluatedUserStatusAction == 'ExternalUserWithIdentityAndNoPassword'"
        >
          <p>Not yet implemented</p>
        </div> -->

        <div v-if="ssoEvaluatedUserStatusAction == 'Undefined'">
          <div
            class="alert alert-danger d-flex justify-content-center align-items-center mt-5"
          >
            <p class="m-0">
              Something went wrong. Please return to login page.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import accountPageMixins from "../../mixins/accountPageMixins";
import TransferUser from "../../components/TransferUser.vue";
import utils from "../../utilities/utils"
import UserAcceptTerms from "./UserAcceptTerms.vue";
import UserPasswordConfirm from "./UserPasswordConfirm.vue";

export default {
  async mounted() {
    if(this.language && this.instance && this.event) {
      this.params = {      
        language: this.language,
        instance: this.instance,
        event: this.event
      }
    } else if (this.$store.getters['ModuleConfig/moduleConfig']?.returnUrl != 'null') {
      this.params = {
        returnUrl: this.$store.getters['ModuleConfig/moduleConfig']?.returnUrl
      }
    }

    if(this.returnUrl) {
      this.params.returnUrl = this.returnUrl;
    }

    await this.ssoEvaluateCurrentUser({ ...this.params }).then(async (nextAction) => {
      if (nextAction === 'userSync') { 
        const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
        this.$router.replace(url)
        return
      }
    })
  },
  data() {
    return {
      userData: '',
      params: null,
    };
  },
  components: {
    TransferUser,
    UserAcceptTerms,
    UserPasswordConfirm   
  },
  mixins: [accountPageMixins],
  props: {
    propHostUrl: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    },
    event: {
      type: String,
      default: ''
    },
    instance: {
      type: String,
      default: ''
    },
    returnUrl: {
      type: String,
      default: ''
    },
  },
  computed: {
    ssoUser() {
      return this.$store.getters["singleSignOn/ssoUser"];
    },
    ssoEvaluatedUserStatusAction() {
      return this.$store.getters["singleSignOn/ssoEvaluatedUserStatusAction"];
    },
    ssoAreTermsAccepted() {
      return this.$store.getters["singleSignOn/ssoAreTermsAccepted"];
    },
    getToken() {
      return this.$store.getters["singleSignOn/ssoUserToken"];
    },
    getRedirectUrl() {
      return this.$store.getters["singleSignOn/ssoRedirectUrl"];
    },
    TransferUser() {
      return this.$store.getters["singleSignOn/ssoTransferUser"];
    },
    ssoError() {
      return this.$store.getters["singleSignOn/ssoError"];
    },
  },
  methods: {},
};
</script>
  
  <style lang="scss" scoped>
.back-link {
  color: #0056b3;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  svg {
    margin-right: 0.5rem;
  }
  &:hover {
    text-decoration: none;
  }
}

.login-container {
  display: flex;
  justify-content: center;

  .login__box {
    display: flex;
    justify-content: center;
    flex-direction: column;

    h1 {
      margin: 20px 0;
    }
    .login__box__login_btn {
      max-width: 200px;
    }
    .login__box__login_btn:disabled {
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .login__box__header,
    .login__box__description {
      display: flex;
      justify-content: center;
    }

    .login__box__description__two {
      display: flex;
      margin-bottom: 15px;
    }

    .login__box__checkbox_link {
      display: flex;
      justify-content: space-between;
    }
    input {
      margin-bottom: 10px;
    }
  }
}

@media (max-width: 668px) {
  .login__box__checkbox_link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.auth__content {
  width: 100vw;
  max-width: 800px;
  margin-top: 10px;
  padding: 15px;
}

.login__box__loader {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading_container {
  min-height: 50vh;
}
</style>
  